import {
  Alert,
  AlertDescription,
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertIcon,
  Button,
  Icon,
} from '@chakra-ui/react'
import { noop } from 'lodash'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { RiDeleteBinLine } from 'react-icons/ri'
import { colors } from '../../../../ui-kit'

interface Props {
  isOpen: boolean
  isDeleting: boolean
  cmFieldName?: string
  closeDeleteDialog(): void
  deleteCustomMetadataField(): void
}

const DeleteDialog = ({
  isOpen,
  isDeleting,
  cmFieldName,
  closeDeleteDialog,
  deleteCustomMetadataField,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const cancelRef = useRef(null)

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={closeDeleteDialog}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="xl" fontWeight="semibold">
            <Icon
              as={RiDeleteBinLine}
              color="appBattleshipGrey"
              backgroundColor="appPaleGrey"
              boxSize={6}
              padding="0.1em"
              borderRadius="full"
              marginRight="0.5em"
            />
            {t('delete_custom_metadata_field', 'Delete custom metadata field')}
          </AlertDialogHeader>

          <AlertDialogCloseButton mr={0} />

          <AlertDialogBody color="appBattleshipGrey">
            {t('are_you_sure_delete_parametrized', {
              entityName: cmFieldName ?? '',
            })}

            <Alert status="warning" marginTop={"8px"}style={{minWidth:"80%",width:"330px"}}>
            <AlertIcon
              height="1em"
              width="1em"
              alignItems="flex-start"
              marginTop="4px"
            />
            <AlertDescription fontSize="sm"  color="appDarkIndigo">
              {t('delete_custom_metadata_warning','Even after deleting a custom metadata field, you cannot create any new custom metadata field with the same name.')}
            </AlertDescription>
          </Alert>

          </AlertDialogBody>

          <AlertDialogFooter
            borderTop="1px solid #f2f2f4"
            style={{ gap: '1em' }}
          >
            <Button
              ref={cancelRef}
              variant="outline"
              onClick={closeDeleteDialog}
            >
              {t('cancel', 'Cancel')}
            </Button>
            <Button
              isLoading={isDeleting}
              loadingText={t('deleting', 'Deleting')}
              colorScheme={colors.appRed}
              onClick={async () => {
                try {
                  await deleteCustomMetadataField()
                  closeDeleteDialog()
                } catch (err) {
                  noop()
                }
              }}
            >
              {t('delete', 'Delete')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export default DeleteDialog
